import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

export const EntryForm = ({ createfunc, drawTicket, game, actions }) => {
    const initialState = {
        ticket1_1_1: '',
        ticket1_1_2: '',
        ticket1_2_1: '',
        promotion_game_id: '',
        promotion: '',
        entry_method: 'MANUAL_WEB',
        form_submitted: '1',
        'entry-submit': 'SUBMIT+ENTRY',
    };

    const query = useQuery();
    const [formState, setFormState] = useState(initialState);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        clearIfSuccess();
    }, [drawTicket]);

    useEffect(async () => {
        if (game.activeGames.length === 0) {
            await actions.gameActions.getActiveGames();
        }
    }, []);

    // fire the submission
    const handleSubmit = async (event) => {
        event.preventDefault();

        setDisabled(true);
        await createfunc(formState);
        document.getElementById('entry-alert').scrollIntoView(true);
        setDisabled(false);
    };

    const convertAlphaNumeric = (str) => {
        return str?.replace(/[^a-z0-9]/gi, '');
    };

    // if the form field changes, we will change the value in the store and
    // also check if the next field must be focused
    const handleChange = function (event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : convertAlphaNumeric(target?.value?.toUpperCase());
        const name = target.name;

        setFormState({ ...formState, [name]: value });
    };

    const selectGame = function (selectedGameId) {
        const selectedGame = game?.activeGames.find(({ game_id }) => game_id === selectedGameId);
        setFormState({
            ...formState,
            promotion: selectedGame?.promotion_id,
            promotion_game_id: selectedGameId,
        });
    };

    // if the form submit was a success, we clear the form
    const clearIfSuccess = async () => {
        if (drawTicket.success) {
            setFormState(initialState);
            actions.entryActions.getEntries();
        }
    };

    useEffect(() => {
        selectGame(query.get('game_id'));
    }, [game]);

    return (
        <div id='form-target' className='entry-form'>
            <form name='ticket_entry' id='ticket_entry' disabled={disabled} method='post' encType='application/x-www-form-urlencoded' onSubmit={handleSubmit}>
                <div className='entry-fields mb-2'>
                    <div className='form-group m-2'>
                        <label htmlFor='promotion_game_id' className='input-label'>
                            GAME NAME (GAME NUMBER)
                        </label>
                        <select
                            name='promotion_game_id'
                            id='promotion_game_id'
                            className='form-control entry-input text-uppercase'
                            value={formState?.promotion_game_id ?? ''}
                            onChange={(e) => selectGame(e.target.value)}>
                            <option value='' data-promotion='0'>
                                Select Game
                            </option>
                            {game?.activeGames?.map(({ game_id, game_name }, idx) => {
                                return <option value={`${game_id}`} key={idx}>{`${game_name} - ${game_id}`}</option>;
                            })}
                        </select>
                    </div>

                    <div className='form-group m-2'>
                        <label htmlFor='ticket1_1_1' className='input-label'>
                            ENTRY CODE
                        </label>
                        <input
                            type='text'
                            name='ticket1_1_1'
                            id='ticket1_1_1'
                            title='Integer Value'
                            value={formState?.ticket1_1_1 || ''}
                            onChange={handleChange}
                            size='11'
                            maxLength='11'
                            className='form-control entry-input'
                        />
                    </div>
                </div>
                <div className='form-group text-center'>
                    <input
                        id='entry-submit'
                        type='submit'
                        alt='Submit Entry'
                        name='submit'
                        className='theme-btn theme-btn-solid-yellow theme-btn-lg entry-submit m-auto'
                        value='SUBMIT ENTRY'
                        title='Submit Entry'
                        disabled={disabled}
                    />
                </div>
                <input type='hidden' id='entry_method' name='entry_method' value={formState.entry_method} />
                <input type='hidden' id='form_submitted' name="form_submitted: '1'" value={formState.form_submitted} />
            </form>
        </div>
    );
};

export default EntryForm;
